module.exports = __webpack_public_path__ + "static/media/notallowed.a9aad8c3.svg";